import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';


/**
 * Generated class for the EditbankofficialsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editbankofficials',
  templateUrl: 'editbankofficials.html',
})
export class EditbankofficialsPage {
  official: any
  Title = ''
  cb: any;
  officialname = ''
  officialpin = ''
  poiid = ''

  public toggle: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private cpService: ColorPickerService, public toastCtrl: ToastController) {
    this.official = this.navParams.get('official')
    this.cb = navParams.get('cb');
    this.poiid = this.navParams.get('poiid')

    if (this.official.id == -1) {
      this.Title = this.dic.l["newofficial"]
    } else {
      this.Title = this.dic.l["editofficial"] + ': ' + this.official.officialname
      this.officialname = this.official.officialname
      this.officialpin = this.official.officialpin
    }
  }

  public onEventLog(event: string, data: any): void {
    console.log(event, data);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditbankofficialsPage');
  }

  isNumber(numb) {
    if (numb + '' != '' && numb % 1 === 0) {
      return true
    }
    else {
      return false
    }
  }

  Save() {
    if (this.officialname == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterofficialname"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.officialpin == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterofficialpin"], duration: 3000, position: 'top' });
      toast.present();
      return
    } else {
      if (this.officialpin.length != 4 || !this.isNumber(this.officialpin)) {
        let toast = this.toastCtrl.create({ message: this.dic.l["entervalidpin"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    var _that = this;
    var dat = {
      offname: this.gn.crypt(this.officialname),
      offpin: this.gn.crypt(this.officialpin),
      poiid: this.gn.crypt(this.poiid)
    }
    // //this.gn.disableBtn();
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/addpoibankofficials', dat, function (_data) {
      if (_data.msg == 'exist') {
        _that.gn.tfBtn = false;
        let toast = _that.toastCtrl.create({ message: _that.dic.l["existPin"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        _that.navCtrl.pop();
        _that.cb();
        _that.gn.tfBtn = false;
      }
    })
    // debugger
  }

  Edit() {
    if (this.officialname == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterofficialname"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.officialpin == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterofficialpin"], duration: 3000, position: 'top' });
      toast.present();
      return
    } else {
      if (this.officialpin.length != 4 || !this.isNumber(this.officialpin)) {
        let toast = this.toastCtrl.create({ message: this.dic.l["entervalidpin"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }

    var _that = this;
    var dat = {
      oid: this.gn.crypt(this.official.id),
      offname: this.gn.crypt(this.officialname),
      offpin: this.gn.crypt(this.officialpin),
      poiid: this.gn.crypt(this.poiid)

    }

    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/editpoibankofficials', dat, function (_data) {
      if (_data.msg == 'exist') {
        _that.gn.tfBtn = false;
        let toast = _that.toastCtrl.create({ message: _that.dic.l["existPin"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        _that.navCtrl.pop();
        _that.cb();
        _that.gn.tfBtn = false;
      }
    })

  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/poisettings/bankofficials/editbankofficials.ts